import type { QueryClient } from "@tanstack/react-query";
import { QueryClient as QueryClientImpl } from "@tanstack/react-query";
import type { DatadogRumService } from "@frontend/shared/infrastructure/monitoring/datadog-rum.interface";
import { DatadogRumServiceImpl } from "@frontend/shared/infrastructure/monitoring/datadog-rum";

export interface CoreModuleType {
  readonly queryClient: QueryClient;
  readonly datadogRumService: DatadogRumService;
}

const QUERY_CLIENT_OPTIONS = {
  queries: {
    refetchOnWindowFocus: false,
    retry: 1,
    staleTime: 5 * 60 * 1000, // 5 minutes
  },
  mutations: {
    retry: 0,
  },
} as const;

const queryClientInstance = new QueryClientImpl({
  defaultOptions: QUERY_CLIENT_OPTIONS,
});

const datadogRumServiceInstance = DatadogRumServiceImpl.getInstance();

datadogRumServiceInstance.initialize({ service: "planta-v2-user" });

export const CoreModule: CoreModuleType = {
  queryClient: queryClientInstance,
  datadogRumService: datadogRumServiceInstance,
};
